<template lang="">
    <div class="quickMenu">
        <ul v-show="isOpen">
            <li>    
                <a href="#" @click.prevent="$router.push('/campaign/campaign-dtl/17')">
                    <p>기부 근조화환</p>
                    <span>형식과 품격을 갖춘 <br>부고 후원 서비스</span>
                </a>
            </li>
            <li>
                <a href="#" @click.prevent="$router.push('/campaign/campaign-dtl/16')">
                    <p>기부 축하화환</p>
                    <span>당신의 기쁜날을<br>공유하는 기부 화원</span>
                </a>
            </li>
        </ul>
        <button type="button" class="toggle_btn" @click="toggleMenu">
            {{ isOpen ? '닫기' : '열기' }}
        </button>
        <button type="button" class="top_btn" @click="toTop">

        </button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isOpen: true
        }
    },    
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
        },
        toTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }
}
</script>
<style lang="">
    
</style>